var $ = jQuery.noConflict();
$(document).ready(function() {

// Mega menu ............ 
  let items = document.querySelectorAll(".header__inline-menu details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

  $(document).on('change', '.itg_select_option', function(e){
    e.preventDefault();
    var selVal = $(this).val();
    $('.itg_color_button_hide label').each(function(){
      var title = $(this).attr('title');
      if(title === selVal){ 
        $(this).trigger('click');
      }
    })


    var imgId222 = $('.product__media-item.grid__item.slider__slide.is-active').attr('data-img-id');

    $('.thumbnail-list__item.slider__slide[data-img-id]').removeClass('clickeditg--5');
   // $('.thumbnail-list__item.slider__slide[data-img-id="'+imgId222+'"]').trigger('click');
    // $('.thumbnail-list__item.slider__slide[data-img-id="'+imgId222+'"]:not(.slick-cloned)').addClass('clickeditg--5');
    $('.thumbnail-list__item.slider__slide[data-img-id="'+imgId222+'"]').not('.slick-cloned').addClass('clickeditg--5');



    setTimeout(function() {
      $('.clickeditg--5').trigger('click');
      var Getinx = $('.clickeditg--5').attr('data-slick-index');
      // $('.thumbnail-list').slickGoTo(Getinx);
      $('.thumbnail-list').slick( 'slickGoTo', Getinx );

    }, 100);

    


    
    
    
    
    
    // $('.product__media-item.grid__item.slider__slide.is-active').each(function(){
    //   var varimgId = $(this).attr('data-imgid');
    //   if(varimgId === imgId){
    //     var vartitle = $(this).attr('data-color');
    //     $('label.color__swatches.product-sw[title="'+vartitle+'"]').trigger('click');      
    //     $('.itg_select_option').val(vartitle).trigger('change');
    //   }
    // });


    
  });


  

  $(document).on('click', 'li.thumbnail-list__item.slider__slide', function() {
    $(this).addClass('slick-current activeBorderImg');
    $(this).siblings().removeClass('slick-current activeBorderImg');
    
  });

  $(document).on('click', '.thumbnail', function(){
    var imgId = $(this).parent('.thumbnail-list__item').attr('data-imgid');
    $('.variantImgval .imageCheck').each(function(){
      var varimgId = $(this).attr('data-imgid');
      if(varimgId === imgId){
        var vartitle = $(this).attr('data-color');
        $('label.color__swatches.product-sw[title="'+vartitle+'"]').trigger('click');      
        $('.itg_select_option').val(vartitle).trigger('change');
      }
    });
    
    setTimeout (function() {
      var indexnomuber = $('.itg_thumbnail-list .slick-current.slick-active').attr('data-slick-index');
          indexnomuber = Number(indexnomuber);
        $('.main_img_list ').slick('slickGoTo', indexnomuber);
        console.log(indexnomuber);
    }, 200);
    
  }); 

  // itg js
  
  $(document).on('click', '.thumb_img .slick-arrow', function(){
    var imgId = $(this).parent('.thumbnail-list').find('li.thumbnail-list__item.slick-current.slick-active').attr('data-imgid');
    $('.variantImgval .imageCheck').each(function(){
      var varimgId = $(this).attr('data-imgid');
      if(varimgId === imgId){
        var vartitle = $(this).attr('data-color');
        $('label.color__swatches.product-sw[title="'+vartitle+'"]').trigger('click');      
        $('.itg_select_option').val(vartitle).trigger('change');
      }
    });
  });

  $('.main_img_list').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
   	var mySlideNumber = nextSlide;
    console.log(nextSlide);
      var thumbId = $('.itg_thumbnail-list .slick-current.slick-active').attr('data-imgid');
       $('.variantImgval .imageCheck').each(function(){
         var varimgId = $(this).attr('data-imgid');
          if(varimgId === thumbId){
            var vartitle = $(this).attr('data-color');
            $('label.color__swatches.product-sw[title="'+vartitle+'"]').trigger('click');      
            $('.itg_select_option').val(vartitle).trigger('change');
          }
        });
  });
// itg js end

  $('#down_btn').click(function(e) {
		e.preventDefault();
		var v = $(this).offset().top + 150;
		$('body,html').animate({scrollTop: v}, 300);
  });


  // itg js 
  if(window.matchMedia("(max-width: 749px)").matches) {

   $('.main_img_list').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        swipeToSlide: true,
        asNavFor: '.itg_thumbnail-list',
        draggable: false
    });
        // draggable: false
    
    $('.itg_thumbnail-list').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.main_img_list',
        infinite: true,
        arrows: true,
        prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M15 18.7913L9 12.7913L15 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
        nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg class="chevron--right" width="24" height="25" viewBox="0 0 24 25" fill="none"><path d="M9 18.7913L15 12.7913L9 6.79126" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>'
    });  

  }
  // itg js end
  });                  

$(document).find('show-more-button').trigger('click');

if(window.matchMedia("(min-width: 1024px)").matches) {
  $(function() {
    $('.zoom-image').each(function(){
      var originalImagePath = $(this).find('img').data('original-image');
      $(this).zoom({
        url: originalImagePath
      });
    });
  });
}

// $(this)
//   $('.clasgrid1').empty().remove();

$('.custm_search > .grid__item.search').each(function(){
  
  //$(this).empty().remove();

str = $(this).text();
if($.trim(str) === "") {
$(this).remove();
}

  
  
});



$(function () {
    $(".custm_search > .grid__item.search").slice(0, 28).show();
    $("#loadMore").on('click', function (e) {
        e.preventDefault();
        $(".custm_search > .grid__item.search:hidden").slice(0, 28).slideDown();
     
        if ($(".custm_search > .grid__item.search:hidden").length == 0) {
            $("#loadMore").fadeOut();
        }
        // $('html,body').animate({
        //     scrollTop: $(this).offset().top
        // }, 1500);
    });
});



 const SwymGrProductGridImgSize = () => {
    $('.product-card-wrapper .card__media img[srcset]').each(function() {
      // console.log($(this).attr('sizes'));
      var SwymGrGetWidth = $(this).parents('li').width().toFixed() + 'px';
      $(this).attr('sizes', SwymGrGetWidth);
      console.log(SwymGrGetWidth);
    });
  }

  setTimeout (function() {
    SwymGrProductGridImgSize();
  }, 1000);

  // $(window).on('load', function() {
  //   setTimeout (function() {
  //    // SwymGrProductGridImgSize();
  //   }, 2000);
  // });



